import {
  collection,
  addDoc,
  getDocs,
  deleteDoc,
  updateDoc,
  query,
  where,
  doc,
} from "firebase/firestore";
import { firestore } from "./firebase";

// додавання користувача в Firestore
export const addDataToFirestore = async (data) => {
  try {
    const docRef = await addDoc(collection(firestore, "users"), data);
    return docRef.id;
  } catch (error) {
    console.error("Помилка додавання користувача:", error);
  }
};

export const addProjectFirestore = async (data) => {
  try {
    const docRef = await addDoc(collection(firestore, "projects"), data);
    return docRef.id;
  } catch (error) {
    console.error("Помилка додавання:", error);
  }
};

// отримання всіх даних з Firestore
export const getDataFromFirestore = async () => {
  try {
    const querySnapshot =
      (await getDocs(collection(firestore, "projects"))) || [];

    const res = querySnapshot.docs.map((doc) => {
      return {
        idDoc: doc.id,
        ...doc.data(),
      };
    });

    if (!Array.isArray(res)) {
      throw new Error("Полученные данные не являются массивом.");
    }
    return res;
  } catch (error) {
    console.error("Помилка отримання:", error);
  }
};

// Видалення даних
export const deleteProjectByInternalId = async (internalId) => {
  try {
    const data = await getDataFromFirestore();
    const projectToDelete = data.find((project) => project.id === internalId);
    if (projectToDelete) {
      const docRef = doc(firestore, "projects", projectToDelete.idDoc);
      await deleteDoc(docRef);
    } else {
      console.log(`Проєкт з внутрішнім id ${internalId} не знайдений.`);
    }
  } catch (error) {
    console.error("Помилка видалення  проєкту:", error);
  }
};

export const updateProjectInFirestore = async (internalId, updatedData) => {
  try {
    // Отримання всіх даних з Firestore
    const data = await getDataFromFirestore();

    // Знаходимо проект для оновлення
    const projectToUpdate = data.find((project) => project.id === internalId);

    if (projectToUpdate) {
      // отримання посилання на документ
      const docRef = doc(firestore, "projects", projectToUpdate.idDoc);
      // Оновлення даних
      await updateDoc(docRef, updatedData);

      console.log(`Проект с внутренним id ${internalId} обновлён.`);
    } else {
      console.log(`Проект с внутренним id ${internalId} не найден.`);
    }
  } catch (error) {
    console.error("Ошибка обновления проекта:", error);
  }
};

export const checkUserCredentials = async (username, password) => {
  try {
    const usersRef = collection(firestore, "users"); // Колекція користувачів
    const q = query(
      usersRef,
      where("username", "==", username),
      where("password", "==", password)
    ); // Запит на збіг username та password
    const querySnapshot = await getDocs(q);

    if (!querySnapshot.empty) {
      console.log("Користувач знайдений:", querySnapshot.docs[0].data());
      return querySnapshot.docs[0].data(); // Повертаємо дані користувача
    } else {
      console.log("Невірне ім'я користувача або пароль.");
      return null;
    }
  } catch (error) {
    console.error("Помилка перевірки користувача:", error);
    return null;
  }
};
